
import { DocumentIcon, PhotoIcon } from '@heroicons/react/24/outline';

import { Icon } from '@/components/core/Icon';
import { cn } from '@/services/utils';

import { ReactComponent as HeroFileCode } from '../../assets/icons/document-code.svg';
import { ReactComponent as HeroFileWord } from '../../assets/icons/document-doc.svg';
import { ReactComponent as HeroFileJson } from '../../assets/icons/document-json.svg';
import { ReactComponent as HeroFilePdf } from '../../assets/icons/document-pdf.svg';
import { ReactComponent as HeroFilePpt} from '../../assets/icons/document-ppt.svg';
import { ReactComponent as HeroFileText } from '../../assets/icons/document-txt.svg';
import { ReactComponent as HeroFileExcel } from '../../assets/icons/document-xls.svg';
import { ReactComponent as HeroFileArchive } from '../../assets/icons/document-zip.svg';

interface FileTypeIconProps {
  fileType: string;
  className?: string;
}

const JsonIcon = ({fileType, className}: {fileType: string; className?: string}) => (
    <div className={cn('tw-relative tw-inline-flex tw-h-7 tw-w-7 tw-shrink-0 tw-items-center tw-justify-center tw-overflow-visible', className)}>
        <Icon icon={DocumentIcon} variant='secondary' className="tw-h-full tw-w-full tw-overflow-visible" />
        <span className="icon-variant-secondary tw-pointer-events-none tw-absolute tw-left-1/2 tw-top-[58%] tw--translate-x-1/2 tw-font-mono tw-text-[8px] tw-leading-none">
            {fileType}
        </span>
    </div>
);

const FileTypeIcon = ({ fileType, className }: FileTypeIconProps) => {
    const variant='secondary';
    const size = cn('tw-h-7 tw-w-7 tw-shrink-0 tw-overflow-visible', className);
    if (fileType) {
        switch (fileType.toLowerCase()) {
            case 'image':
                return <Icon colorScheme='normal' icon={PhotoIcon} size={className ? undefined : 'xl'} variant='secondary' className={className}/>;
            case 'code':
            case 'xml':
                return <HeroFileCode className={`icon-variant-${variant} ${size}`}/>;
            case 'json':
                return <HeroFileJson className={`icon-variant-${variant} ${size}`}/>;
            case 'excel':
                return <HeroFileExcel className={`icon-variant-${variant} ${size}`}/>;
            case 'word':
                return <HeroFileWord className={`icon-variant-${variant} ${size}`}/>;
            case 'powerpoint':
                return <HeroFilePpt className={`icon-variant-${variant} ${size}`}/>;
            case 'pdf':
                return <HeroFilePdf className={`icon-variant-${variant} ${size}`} data-testid="file-pdf"/>;
            case 'zip':
                return <HeroFileArchive className={`icon-variant-${variant} ${size}`}/>;
            case 'text':
                return <HeroFileText className={`icon-variant-${variant} ${size}`}/>;
            default:
                return <JsonIcon fileType={fileType.substring(0, 3)} className={className} />;
        }
    }

};

export default FileTypeIcon;
